import { Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledAvatar = styled(Avatar)(() => ({
  width: '28px',
  height: '28px',
})) as typeof Avatar;

export default StyledAvatar;
